import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            
            if (err.status === 401 || err.status === 403) {

                // auto logout if 401 response returned from api
                localStorage.removeItem('currentUser');
                // sessionStorage.setItem('returnUrl', this.router.url);

                // reload the page to clear the cache
                location.reload();

                // Rethrow the original HttpErrorResponse unchanged (same as the status === 0
                // case below) so callers that fire before the reload takes effect - e.g. the
                // tablet-sign kiosk page, which has its own reason to react to a 401/403 - can
                // still read `err.status` instead of getting the extracted message string.
                return throwError(() => err);
            }

            if (err.status === 0) {
                // No response reached us at all (offline/unreachable backend) - rethrow the
                // original HttpErrorResponse unchanged so callers can detect a network failure
                // (err.status === 0) instead of a real server rejection.
                return throwError(() => err);
            }

            // `err.error` is null for an empty-body response (e.g. a gateway 502/504).
            const error = err.error?.message || err.error || err.statusText;
            return throwError(() => error);
        }))
    }
}